'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _merge = require('lodash/merge');

var _merge2 = _interopRequireDefault(_merge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref, _ref2) {
  var background = _ref.background,
      block = _ref.block,
      borderColor = _ref.borderColor,
      borderWidth = _ref.borderWidth,
      effect = _ref.effect,
      font = _ref.font,
      foreground = _ref.foreground,
      radius = _ref.radius,
      shadow = _ref.shadow,
      size = _ref.size,
      spacing = _ref.spacing,
      styles = _ref.styles;
  var calculateSpacing = _ref2.calculateSpacing,
      colors = _ref2.colors,
      effects = _ref2.effects,
      radiuses = _ref2.radiuses,
      rhythm = _ref2.rhythm,
      scale = _ref2.scale,
      shadows = _ref2.shadows,
      treatments = _ref2.treatments;
  return {
    root: (0, _merge2.default)(_extends({
      display: block ? 'block' : 'inline-block',
      width: block ? '100%' : 'auto',
      cursor: 'pointer',
      textDecoration: 'none',
      overflow: 'hidden',
      transform: 'translateZ(0)', // workaround for transition vs overflow:hidden/border-radius bug
      verticalAlign: 'middle',
      textAlign: 'center'
    }, calculateSpacing(spacing), {
      backgroundColor: colors[background] || colors.primary,
      color: colors[foreground] || colors.light,
      border: borderWidth + 'px solid ' + colors[borderColor],
      borderRadius: rhythm(radiuses[radius]),
      boxShadow: shadow && shadows[shadow],
      fontSize: scale(size)
    }, treatments[font], effects[effect], {

      '& > *': {
        margin: rhythm([0, 0.125])
      },

      '& > *:first-child': {
        marginLeft: 0
      },

      '& > *:last-child': {
        marginRight: 0
      },

      '& > *:first-child:last-child': {
        display: 'block' // removes awkward spacing around single child e.g. share icon
      }
    }), styles)
  };
};


//////////////////
// WEBPACK FOOTER
// ../~/constructicon/button/styles.js
// module id = 879
// module chunks = 0